<template>
  <div :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <div role="group" class="form-group mb-2">
      <label class="d-block font-weight-bold">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
      <div
        class="form-check px-0"
        :class="
          label == undefined ? (mt == undefined ? 'mt-4' : `mt-${mt}`) : ''
        "
        v-for="(item, index) in array"
        :key="index"
      >
        <div role="group" class="form-group mb-2 d-flex align-items-center">
          <toggle-button
            :sync="true"
            color="#5685D8"
            :v-model="item.checked"
            :value="item.checked"
            @input="selected = index"
            @change="setValue"
          />
          <span class="pl-2" v-html="item.value"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["value", "itens", "label", "required", "grid", "id", "mt"],
    data() {
      return {
        finds: [],
        selected: 0,
        array: [],
      };
    },
    mounted() {
      if (this.itens) {
        this.setArray();
      }

      if (this.value == undefined) {
        for (var i = 0; i < this.itens.length; i++) {
          this.finds[i] = false;
        }
      }
    },
    watch: {
      value(n, o) {
        if (this.value) {
          this.finds = Array.from(this.value);
        }
        if (this.itens) {
          this.setArray();
        }
      },
      itens(n, o) {
        this.setArray();
      },
    },
    methods: {
      check(i) {
        if (this.value != undefined) {
          if (this.value[i] === "true" || this.value[i] === true) {
            this.finds[i] = true;
            return true;
          } else if (this.value[i] === "false" || this.value[i] === false) {
            this.finds[i] = false;
            return false;
          }
        } else {
          return false;
        }
      },
      setArray() {
        this.array = this.itens.map((el, index) => ({
          id: el.id,
          value: el.value,
          checked: this.check(index),
        }));
      },
      setValue(event) {
        this.finds[this.selected] = event.value;
        this.$emit("input", this.finds);
      },
    },
  };
</script>
